import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getAtsJobCreate } from '@/store/atsJobCreate';
import { Stars03 } from '@kula-ai/icons-core';

interface NoteTakerConfigProps {
  config?: Record<string, unknown>;
  fieldProps?: Record<string, unknown>;
}

export const useNoteTakerConfig = (props: NoteTakerConfigProps = {}) => {
  const { currentJob = {} } = useSelector(getAtsJobCreate, shallowEqual);

  const isNoteTakerMandatory = currentJob?.data?.note_taker?.mandatory ?? false;

  const formConfig = useMemo(
    () => ({
      type: 'switch',
      name: 'enable_note_taker',
      required: isNoteTakerMandatory,
      condition: {
        operator: 'in',
        field: 'location',
        value: ['zoom', 'google_meet', 'teams'],
      },
      classNames: {
        container: 'bg-secondary-25 p-4 rounded-lg border border-secondary-100',
      },
      ...(props.config || {}),
      fieldProps: {
        switchLabel: 'Enable AI notetaker?',
        description:
          'The AI Notetaker automatically captures key points and summaries during meetings.',
        labelLeftElement: React.createElement(Stars03, {
          size: 18,
          className: 'text-primary-600',
        }),
        fullWidth: true,
        labelPosition: 'left',
        ...(props.fieldProps || {}),
      },
    }),
    [props, isNoteTakerMandatory]
  );

  return formConfig;
};
